import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  canonical?: string;
}
export function SEO({
  title = 'Justus Kraft - CRM Expert | Sales Automation Specialist',
  description = 'Started my first business at 16. Now at 23, I help companies double their sales through intelligent CRM systems. 110+ happy clients, GDPR compliant, $7M+ in additional revenue generated.',
  keywords = 'CRM expert, sales automation, CRM consulting, Justus Kraft, B2B sales, B2C sales, CRM systems, sales optimization, revenue growth, lead management, customer relationship management',
  ogImage = 'https://cdn.magicpatterns.com/uploads/jWaCxaLsc32b7Nk2LkzDn3/62dfd10966fa026013ebcbcf_565aa1ce-min-p-1600_(3).jpg',
  ogType = 'website',
  canonical
}: SEOProps) {
  const siteUrl = typeof window !== 'undefined' ? window.location.origin : 'https://kraftjustus.com';
  const currentUrl = typeof window !== 'undefined' ? window.location.href : siteUrl;
  const canonicalUrl = canonical || currentUrl;
  const faviconUrl = 'https://cdn.magicpatterns.com/uploads/vy5bw8FhBjPCpPJJJ1fQji/facicon-jk-144.png';
  return <Helmet data-id="element-127" data-mp="1zj08z4s2nw6i">
      {/* Primary Meta Tags */}
      <title data-id="element-128" data-mp="1ul8dy1w4rty3">{title}</title>
      <meta name="title" content={title} data-id="element-129" data-mp="1ulzxufgd838j" />
      <meta name="description" content={description} data-id="element-130" data-mp="1ukykg4bvn4nn" />
      <meta name="keywords" content={keywords} data-id="element-131" data-mp="1qjv6jnde3ip2" />

      {/* Favicon - Multiple sizes for different contexts */}
      <link rel="icon" type="image/png" sizes="144x144" href={faviconUrl} data-id="element-132" data-mp="1lrvc2ag39hzv" />
      <link rel="icon" type="image/png" sizes="32x32" href={faviconUrl} data-id="element-133" data-mp="1gtae6hob7ael" />
      <link rel="icon" type="image/png" sizes="16x16" href={faviconUrl} data-id="element-134" data-mp="1grh7j2dp4q6l" />
      <link rel="shortcut icon" href={faviconUrl} data-id="element-135" data-mp="1bwjw5osy24qj" />

      {/* Apple Touch Icon */}
      <link rel="apple-touch-icon" sizes="144x144" href={faviconUrl} data-id="element-136" data-mp="16ucimusgugm3" />

      {/* Android/Chrome */}
      <link rel="icon" sizes="192x192" href={faviconUrl} data-id="element-137" data-mp="12ukfwypr74on" />

      {/* Microsoft Tiles */}
      <meta name="msapplication-TileImage" content={faviconUrl} data-id="element-138" data-mp="s85nkcv15nyp" />
      <meta name="msapplication-TileColor" content="#0A0E27" data-id="element-139" data-mp="x7rxacbngm2r" />

      {/* Language */}
      <html lang="en" data-id="element-140" data-mp="j88v005is4yd" />

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} data-id="element-141" data-mp="j9tnlk89xdtl" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-142" data-mp="o8ddfvpzn9r8" />
      <meta property="og:url" content={currentUrl} data-id="element-143" data-mp="1bwwj03hnl8fm" />
      <meta property="og:title" content={title} data-id="element-144" data-mp="1by7ktxrjg643" />
      <meta property="og:description" content={description} data-id="element-145" data-mp="1fyi1q5gvcgxq" />
      <meta property="og:image" content={ogImage} data-id="element-146" data-mp="1fxzvcg0hsmc3" />
      <meta property="og:locale" content="en_US" data-id="element-147" data-mp="127mraoqq1rs1" />
      <meta property="og:site_name" content="Justus Kraft" data-id="element-148" data-mp="126uujale1o06" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-149" data-mp="174wlsisywtmq" />
      <meta property="twitter:url" content={currentUrl} data-id="element-150" data-mp="1uv8sxrge2mc9" />
      <meta property="twitter:title" content={title} data-id="element-151" data-mp="1utpd21ynadb0" />
      <meta property="twitter:description" content={description} data-id="element-152" data-mp="1znk4jrkhrwkn" />
      <meta property="twitter:image" content={ogImage} data-id="element-153" data-mp="2912f0w0vi8ni" />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" data-id="element-154" data-mp="24zp6ge6ebrcw" />
      <meta name="author" content="Justus Kraft" data-id="element-155" data-mp="24yxo451t7q4k" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" data-id="element-156" data-mp="2ir40dg1udcyq" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" data-id="element-157" data-mp="2it88ka6rwy4t" />

      {/* Theme Color for mobile browsers */}
      <meta name="theme-color" content="#0A0E27" data-id="element-158" data-mp="1q26llmwu9yaq" />

      {/* Structured Data - Organization */}
      <script type="application/ld+json" data-id="element-159" data-mp="1m0uvlga1zb20">
        {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Justus Kraft',
        legalName: 'Justus Kraft LLC',
        description: 'CRM consulting and sales automation solutions that help companies build practical, high-adoption CRM systems.',
        url: siteUrl,
        image: ogImage,
        logo: ogImage,
        address: {
          '@type': 'PostalAddress',
          streetAddress: '7901 4th St. N, Ste. 300',
          addressLocality: 'St. Petersburg',
          addressRegion: 'FL',
          postalCode: '33702',
          addressCountry: 'US'
        },
        telephone: '+1 424-678-0686',
        email: 'jk@kraftjustus.com',
        founder: {
          '@type': 'Person',
          name: 'Justus Kraft'
        }
      })}
      </script>

      {/* Structured Data - Service */}
      <script type="application/ld+json" data-id="element-160" data-mp="1yy6t8z2ifond">
        {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Service',
        serviceType: 'CRM Consulting and Sales Automation',
        provider: {
          '@type': 'Organization',
          name: 'Justus Kraft'
        },
        areaServed: [{
          '@type': 'Country',
          name: 'Germany'
        }, {
          '@type': 'Country',
          name: 'Europe'
        }],
        description: 'Professional CRM consulting and sales automation for businesses. Combining IT expertise with sales experience to deliver practical, high-adoption CRM solutions.',
        offers: {
          '@type': 'Offer',
          availability: 'https://schema.org/InStock',
          price: '0',
          priceCurrency: 'EUR',
          description: 'Free initial consultation'
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '5',
          reviewCount: '110'
        }
      })}
      </script>

      {/* Structured Data - Organization */}
      <script type="application/ld+json" data-id="element-161" data-mp="kxkg3fsxqdse">
        {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Justus Kraft',
        legalName: 'Justus Kraft LLC',
        founder: {
          '@type': 'Person',
          name: 'Justus Kraft'
        },
        address: {
          '@type': 'PostalAddress',
          streetAddress: '7901 4th St. N, Ste. 300',
          addressLocality: 'St. Petersburg',
          addressRegion: 'FL',
          postalCode: '33702',
          addressCountry: 'US'
        },
        telephone: '+1 424-678-0686',
        email: 'jk@kraftjustus.com',
        description: 'CRM systems and sales automation solutions built by practitioners for practitioners.',
        url: siteUrl,
        logo: ogImage
      })}
      </script>
    </Helmet>;
}